import React, { memo } from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

// eslint-disable-next-line react/display-name
function Footer() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        Сарафан - поиск профессионалов
      </Link>{' '}
      2018 - {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export default memo(Footer)



// WEBPACK FOOTER //
// ./src/template/Footer/index.jsx